/**
 * Layer state.
 */
export enum LayerState {
  /** Standby state. */
  Standby,
  /** Playing state. */
  Playing,
  /** CrossFading state. */
  CrossFading,
  /** FixedCrossFading state. */
  FixedCrossFading,
  /** Finished state. */
  Finished
}
